export enum PointChangeTypeLabel {
   auto = "Forma wsparcia",
   manual = "Wpisane ręcznie"
}

export const options = [
   { value: "auto", label: PointChangeTypeLabel.auto },
   { value: "manual", label: PointChangeTypeLabel.manual}
] 